<template>
  <div
    v-if="shouldShow"
    class="contact-fab"
    :class="{ 'contact-fab--hidden': hidden }"
    :style="fabStyle"
    @click.stop="onClick"
  >
    <img class="contact-fab__img" :src="iconSrc" alt="联系客服" />
  </div>
</template>

<script>
import { openUseasyWebChat } from "@/utils/useasyKeFu";

const STORAGE_KEY_PENDING_KEFU = "pendingKefuAction";
const TAB_BAR_HEIGHT = 50;
const IDLE_SHOW_DELAY_MS = 600;

function safeJsonParse(s) {
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
}

export default {
  name: "ContactFab",
  data() {
    return {
      hidden: false,
      idleTimer: null,
      lastMoveTs: 0,
      lastScrollY: null,
      cooldownUntil: 0,
      ignoreScrollUntil: 0,
      hasTabbar: false,
    };
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.hasTabbar = !!document.querySelector(".tabbar-container");
      });
    },
  },
  computed: {
    isLoggedIn() {
      const u = String(localStorage.getItem("username") || "").trim();
      const s = String(localStorage.getItem("login_status") || "").trim();
      return !!u && s === "true";
    },
    shouldShow() {
      const meta = (this.$route && this.$route.meta) || {};
      if (!meta.contactFab) return false;
      if (meta.contactFabLoggedInOnly) return this.isLoggedIn;
      return true;
    },
    iconSrc() {
      try {
        return require("@/assets/jsyl/jsyl_kefu.png");
      } catch (e) {
        return "";
      }
    },
    fabStyle() {
      const meta = (this.$route && this.$route.meta) || {};
      const bottom = Number.isFinite(meta.contactFabBottom) ? meta.contactFabBottom : 120;
      const right = Number.isFinite(meta.contactFabRight) ? meta.contactFabRight : 4;
      const size = Number.isFinite(meta.contactFabSize) ? meta.contactFabSize : 52;
      const tabGuard = this.hasTabbar ? TAB_BAR_HEIGHT : 0;
      return {
        right: `${right}px`,
        bottom: `calc(${bottom}px + env(safe-area-inset-bottom) + ${tabGuard}px)`,
        width: `${size}px`,
        height: `${size}px`,
      };
    },
    imCtx() {
      const meta = (this.$route && this.$route.meta) || {};
      const title =
        meta.contactFabTitle != null && meta.contactFabTitle !== ""
          ? String(meta.contactFabTitle)
          : typeof document !== "undefined"
            ? document.title || ""
            : "";
      return {
        imUrlTitle: title,
        imFromUrl: typeof window !== "undefined" ? window.location.href || "" : "",
      };
    },
  },
  mounted() {
    this.ignoreScrollUntil = Date.now() + 500;
    this.hasTabbar = !!document.querySelector(".tabbar-container");
    window.addEventListener("scroll", this.onScrollActivity, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScrollActivity);
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
      this.idleTimer = null;
    }
  },
  methods: {
    onScrollActivity() {
      const now = Date.now();
      const scrollY =
        typeof window !== "undefined"
          ? window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
          : 0;

      const prev = this.lastScrollY;
      if (prev === null) {
        this.lastScrollY = scrollY;
        return;
      }
      if (Math.abs(scrollY - prev) < 2) {
        return;
      }
      this.lastScrollY = scrollY;

      if (now < this.ignoreScrollUntil) {
        return;
      }
      this.lastMoveTs = now;

      const scheduleShow = () => {
        if (this.idleTimer) clearTimeout(this.idleTimer);
        const t = Date.now();
        const untilIdle = IDLE_SHOW_DELAY_MS - (t - this.lastMoveTs);
        const untilCooldown = this.cooldownUntil - t;
        const wait = Math.max(50, untilIdle, untilCooldown);
        this.idleTimer = setTimeout(() => {
          const now2 = Date.now();
          if (now2 - this.lastMoveTs < IDLE_SHOW_DELAY_MS) {
            scheduleShow();
            return;
          }
          if (now2 < this.cooldownUntil) {
            scheduleShow();
            return;
          }
          this.hidden = false;
          this.cooldownUntil = now2 + 600;
        }, wait);
      };
      scheduleShow();

      if (this.hidden) return;
      if (now < this.cooldownUntil) return;
      this.hidden = true;
      this.cooldownUntil = now + 600;
    },
    setPendingKefuAction(payload) {
      if (!payload) {
        sessionStorage.removeItem(STORAGE_KEY_PENDING_KEFU);
        return;
      }
      try {
        sessionStorage.setItem(STORAGE_KEY_PENDING_KEFU, JSON.stringify(payload));
      } catch (e) {
        sessionStorage.removeItem(STORAGE_KEY_PENDING_KEFU);
      }
    },
    onClick() {
      if (this.isLoggedIn) {
        openUseasyWebChat(this.imCtx);
        return;
      }
      const returnUrl = (this.$route && this.$route.fullPath) || "/home";
      this.setPendingKefuAction({
        returnUrl,
        kefuCtx: this.imCtx,
        createdAt: Date.now(),
      });
      this.$router.push({
        path: "/login",
        query: { r: returnUrl },
      });
    },
  },
};
</script>

<style scoped>
.contact-fab {
  position: fixed;
  z-index: 2000;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(0);
  transition: transform 300ms;
  background: transparent;
  box-shadow: none;
}

.contact-fab--hidden {
  transform: translateX(140%);
}

.contact-fab__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
